import styled from "styled-components";

export const Container = styled.div`
  margin-right: auto;
  margin-left: auto;
  padding: 15px 10% 15px 10%;
  background-color: #124028;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h1`
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 300;
  text-transform: uppercase;
`;
